import React from "react"

import { connect } from "scrivito"
import {
  ExternalDimensioningResult,
  ProductInformation
} from "shared/types/__generated__/graphql"
import { LinkProps } from "shared/ui/link/Link"

import { FilteredProductPositionActionHandlers } from "features/product-position-management/model/useProductPositionActionHandlers"
import { ProductPositionFormModel } from "features/product-position-management/types/ProductPositionFormModel"
import { ProductPositionFormOptions } from "features/product-position-management/types/ProductPositionFormOptions"

import { ProjectPageProductPositionSidebarView } from "./ProjectPageProductPositionSidebarView"
import { useProjectPageProductPositionSidebarViewModel } from "./hooks/useProjectPageProductPositionSidebarViewModel"

export interface ProjectPageProductPositionSidebarModel {
  image: React.ReactNode

  productInformation?: ProductInformation | undefined | null
  externalDimensioningResult?: ExternalDimensioningResult | undefined | null
  isLoadingProductInformation?: boolean

  hideShortLabels?: boolean
  isLoadingTitle?: boolean

  titleLinkProps?: LinkProps

  callbacks?: FilteredProductPositionActionHandlers
  formModel: ProductPositionFormModel
  isLoading?: boolean
  isReadonly?: boolean

  hideControls?: boolean

  isEditing: boolean
  enterEditing: () => void
  exitEditing: () => void
  sidebarActiveTab: string | null
  setSidebarActiveTab: (tab: string | null) => void
}

export interface ProjectPageProductPositionSidebarProps
  extends ProjectPageProductPositionSidebarModel {
  isDefaultEditing?: boolean

  formOptions?: ProductPositionFormOptions
}

function ProjectPageProductPositionSidebarComponent(
  props: ProjectPageProductPositionSidebarProps
) {
  return (
    <ProjectPageProductPositionSidebarView
      {...useProjectPageProductPositionSidebarViewModel(props)}
    />
  )
}
export const ProjectPageProductPositionSidebar = React.memo(
  connect(ProjectPageProductPositionSidebarComponent)
) as typeof ProjectPageProductPositionSidebarComponent
